import { ComponentSample, Item } from 'componentregistry';
import type { IconColumn } from './IconColumn';

const page: {
  root: Item<'Page'>;
  flexPanel: Item<'FlexPanel'>;
  flexItem: Item<'FlexItem'>;
  testAliasLocalDataStore: Item<'LocalDataStore'>;
  testAliasDataStoreReference: Item<'DataStoreReference'>;
  dataGrid: Item<'DataGrid'>;
  idNumberColumn: Item<'NumberColumn'>;
  iconColumn: Item<'IconColumn'>;
} = {
  root: {
    children: ['testAliasLocalDataStore', 'flexPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      padding: { all: 0 },
      windowTitle: { type: 'text', value: 'Icon Column Example' },
    },
    type: 'Page',
  },
  flexPanel: {
    children: ['flexItem'],
    itemId: 'flexPanel',
    parent: 'root',
    props: {},
    type: 'FlexPanel',
  },
  flexItem: {
    children: ['testAliasDataStoreReference'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  testAliasLocalDataStore: {
    children: [],
    itemId: 'testAliasLocalDataStore',
    parent: 'root',
    props: {
      alias: 'testAlias',
      dataFormat: 'json',
      dataSource: 'test',
      jsonData: `[
  { "id": 1, "status": "Approved" },
  { "id": 2, "status": "Pending" },
  { "id": 3, "status": "Rejected" },
  { "id": 4, "status": "Pending" },
  { "id": 5, "status": "Approved" }
]`,
    },
    type: 'LocalDataStore',
  },
  testAliasDataStoreReference: {
    children: ['dataGrid'],
    itemId: 'testAliasDataStoreReference',
    parent: 'flexItem',
    props: { alias: 'testAlias' },
    type: 'DataStoreReference',
  },
  dataGrid: {
    children: ['idNumberColumn', 'iconColumn'],
    itemId: 'dataGrid',
    parent: 'testAliasDataStoreReference',
    props: {
      expandLastColumn: false,
      showBorder: true,
      updatable: { type: 'boolean', value: false },
      insertable: { type: 'boolean', value: false },
    },
    type: 'DataGrid',
  },
  idNumberColumn: {
    children: [],
    itemId: 'idNumberColumn',
    parent: 'dataGrid',
    props: {
      allowDecimal: false,
      label: { type: 'text', value: 'ID' },
      viewAttribute: 'id',
      width: 60,
    },
    type: 'NumberColumn',
  },
  iconColumn: {
    children: [],
    itemId: 'iconColumn',
    parent: 'dataGrid',
    props: {
      alignment: 'center',
      label: { type: 'text', value: 'Status Icon' },
      icon: { iconName: 'check-circle' },
      color: { type: 'expression', value: "'success.main'" },
      size: 'medium',
      showOnlyOnHover: false,
      disableCondition: '',
      width: 120,
      toolTip: { type: 'text', value: 'Status indicator icon' },
      //   toolTipPlacement: 'top',
    } as Required<IconColumn>,
    type: 'IconColumn',
  },
};

export const helpRenders: ComponentSample<'IconColumn'>[] = [
  {
    title: 'Icon Column Example',
    page,
    exampleId: 'eg-01GK8QWM9KTAE6TN0ME1F8WQICON',
    clearParentChildren: false,
    height: 420,
    visibleProps: [
      'label',
      'icon',
      'color',
      'size',
      'showOnlyOnHover',
      'disableCondition',
      'toolTip',
      //   'toolTipPlacement',
      'width',
      'pinLeft',
      'pinRight',
      'visible',
      'sortable',
      'filterable',
    ],
    item: {
      children: [],
      itemId: 'iconColumn',
      parent: 'dataGrid',
      type: 'IconColumn',
      props: {
        alignment: 'center',
        label: { type: 'text', value: 'Status Icon' },
        icon: { iconName: 'check-circle' },
        color: { type: 'expression', value: "'success.main'" },
        size: 'medium',
        showOnlyOnHover: false,
        disableCondition: '',
        width: 120,
        toolTip: { type: 'text', value: 'Status indicator icon' },
      } as Required<IconColumn>,
    },
  },
];
